module.exports = __webpack_public_path__ + "static/media/coherelogo.347a9cfe.png";